import { load } from "recaptcha-v3";

export const captcha = async () => {
  const recaptcha = await load("6Le3EyodAAAAAMdGDmVfyigDVOxKtkLVyHQJR6fj", {
    autoHideBadge: true,
  });
  return await recaptcha.execute("submit");
};
